import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { appHttp, unwrap } from '@/shared/http'

export class SummaryApi {
  constructor(private readonly http: AxiosInstance = appHttp) {}

  async getLatestWeekly(workspaceId: string | number, signal?: AbortSignal): Promise<unknown> {
    const config: AxiosRequestConfig = {
      suppressGlobalErrorHandler: true,
      meta: { suppressGlobalErrorHandler: true },
    }
    if (signal) config.signal = signal
    return unwrap(
      await this.http.get(`/notifications/summary/weekly/${workspaceId}/latest/`, config),
    )
  }
}

export const summaryApi = new SummaryApi()
